import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NavComponent } from 'src/app/traits/nav/nav.component';

@Component({
  selector: 'app-view-collection',
  templateUrl: './view-collection.component.html',
  styleUrls: ['./view-collection.component.sass']
})
export class ViewCollectionComponent implements OnInit {

  set: any; id: string; rpt: any;  trans: any[] = []; response: any; 

  private _searhcTitle: string;

  get searchTitle(): string {
    return this._searhcTitle;
  }
  set searchTitle(value: string) {
    this._searhcTitle = value;
  }

  constructor(
    private api: ApiService, 
    private router: ActivatedRoute,
    private use: NavComponent,
    ) { }

  ngOnInit() {
    this.id = this.router.snapshot.paramMap.get('id');
    this.getCollectionDetails(this.id);
    this.rpt = { id: '', type: '', start: '', end: '', code: 0 }
  }


  getCollectionDetails(id: any) {
    this.api.get("Collection/Get/"+id).subscribe((data: any) => {
      this.set = data.data; 
      this.trans = data.payments;
      console.log(data);
      this.use.showMsg('success', 'Request fetched', 'Collection Details fetched successfully');
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Request Failed', 'Unable to fetch Collection Details');
    });
  }
}




